import React, { useEffect } from 'react';

import Button from './common/Button';
import SectionList from './common/sectionList/SectionList';
import SectionListItem from './common/sectionList/SectionListItem';
import { getProfileLanguage } from '../models/ProfileResponse';
import { uiState } from '../atoms/uiAtom';
import { useGetAccount } from '../hooks/accounts';
import { useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

export default function Profile() {
  const { t, i18n } = useTranslation();
  const setUiState = useSetRecoilState(uiState);
  const { isFetching, isError, data: profile } = useGetAccount({ enabled: true });

  useEffect(() => {
    setUiState((state) => ({
      ...state,
      hasError: isError,
    }));
  }, [isError, setUiState]);

  const handleClickModifyPassword = () => {
    window.location.replace(
      `${process.env.REACT_APP_AZURE_B2C_UPDATE_PWD_URL}&ui_locales=${i18n.language}`!
    );
  };

  const handleClickModifyGeneralInfo = () => {
    window.location.replace(
      `${process.env.REACT_APP_AZURE_B2C_EDIT_PROFILE_URL}&ui_locales=${i18n.language}`!
    );
  };

  return (
    <div className="profile p-4">
      <h2>{t('common.profile')}</h2>
      <div className="widget mb-4">
        <SectionList title={t('profile.general.information.identify')}>
          <SectionListItem
            dataTestId="profile-email"
            title={t('profile.general.information.email')}
            value={profile?.data.email}
            isFetching={isFetching}
          />
        </SectionList>
      </div>
      <div className="d-flex justify-content-end mb-4">
        <Button
          dataTestId="profile-modify-general-info-btn"
          className="btn btn--secondary w-auto"
          onClick={handleClickModifyGeneralInfo}
          isDisabled={isFetching || isError}
        >
          {t('common.modify')}
        </Button>
      </div>
      <div className="widget mb-4">
        <SectionList title={t('profile.general.information')} isFetching={isFetching || isError}>
          <SectionListItem
            title={t('profile.general.information.firstname')}
            value={profile?.data.firstname}
            isFetching={isFetching || isError}
          />
          <SectionListItem
            title={t('profile.general.information.lastname')}
            value={profile?.data.lastname}
            isFetching={isFetching || isError}
          />
          <SectionListItem
            title={t('profile.general.information.language')}
            value={t(getProfileLanguage(profile?.data.language))}
            isFetching={isFetching || isError}
          />
          <SectionListItem
            title={t('profile.general.information.phone')}
            value={profile?.data.phoneNumber}
            isFetching={isFetching || isError}
          />
        </SectionList>
      </div>
      <div className="d-flex justify-content-end mb-4">
        <Button
          className="btn btn--secondary w-auto"
          onClick={handleClickModifyPassword}
          isDisabled={isFetching || isError}
        >
          {t('common.modify')}
        </Button>
      </div>
      <div className="widget mb-4">
        <SectionList title={t('profile.mdp')} isFetching={isFetching || isError}>
          <SectionListItem
            title={t('profile.mdp.change')}
            value="********"
            isFetching={isFetching || isError}
          />
        </SectionList>
      </div>
    </div>
  );
}
